export default "__VITE_ASSET__B0UrSswP__"